import { useStore } from 'vuex';

import { StoreModulesNamesEnum } from '@/store/StoreModulesNamesEnum';
import { NotificationMutations } from '@/store/types/mutation-types';
import { IAppNotification } from '@/utils/interfaces';

export interface IUseNotifications {
  addNotification: (notification: IAppNotification) => void;
  addSuccessNotification: (message: string, title?: string) => void;
  showFormValidationErrorNotification: (message?: string) => void;
}

/**
 * App notifications: `<script setup>` calls it directly, an Options component
 * returns what it needs from its `setup()` bridge. Also the counterpart of
 * `AppFormMixin.showFormValidationErrorNotification`.
 */
export const useNotifications = (): IUseNotifications => {
  const store = useStore();

  const addNotification = (notification: IAppNotification): void => {
    store.commit(`${StoreModulesNamesEnum.Notifications}/${NotificationMutations.ADD_NOTIFICATION}`, notification);
  };

  const addSuccessNotification = (message: string, title?: string): void => {
    addNotification({
      status: 200,
      title: title || 'Success',
      message,
    });
  };

  const showFormValidationErrorNotification = (message?: string): void => {
    addNotification({
      status: 0,
      title: 'Error',
      message: message || 'Please fill in all required fields before submitting the form.',
    });
  };

  return { addNotification, addSuccessNotification, showFormValidationErrorNotification };
};
